export const RQ_GET_SYS_LOV_BY_TYPE = {
  url: 'systemlov/by-type/<%= category %>',
  method: 'GET',
  auth: true,
};

export const RQ_GET_RCPA_CATEGORY_LIST = {
  url: 'rcpadefinition/getAll',
  method: 'GET',
  auth: true,
};
